export default __webpack_public_path__ + "static/media/clock-selected.1cfb6e85.svg";